import React from 'react';
import PropTypes from 'prop-types';
import HeaderLink from '../HeaderLink';
import './_widgetContainer.scss';

const WidgetContainer = ({
    title,
    titleIconClassName,
    children,
    titleLink,
    gaComponent = null,
    gtmAttribute,
    onClick,
    isFavouriteSport = false,
}) => {
    const dataGaComponent = gaComponent ? gaComponent : null;

    return (
        <div
            className='c-widgetcontainer'
            data-ga-component={dataGaComponent}
        >
            {
                title
                ? <HeaderLink
                    title={title}
                    link={titleLink}
                    onClick={onClick}
                    gtmAttribute={gtmAttribute}
                    isFavouriteSport={isFavouriteSport}
                    titleIconClassName={titleIconClassName}
                    wrapperClass='c-widgetcontainer'
                />
                : null
            }
            <div className='c-widgetcontainer__container'>
                {children}
            </div>
        </div>
    );
};

WidgetContainer.propTypes = {
   title: PropTypes.node,
   titleIconClassName: PropTypes.string,
   seeAllText: PropTypes.string,
   titleLink: PropTypes.string,
   isFavouriteSport: PropTypes.bool,
   children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
   gaComponent: PropTypes.string,
   gtmAttribute: PropTypes.string,
   onClick: PropTypes.func,
};


export default WidgetContainer;
